"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _loginViewSelector = require("./loginViewSelector");
require("./styles.scss");
var _teacherAndParentLogin = require("./teacherAndParentLogin");
var _reactRouterDom = require("react-router-dom");
var _studentLogin = require("./studentLogin");
var _usernameLogin = require("./studentLogin/usernameLogin");
var _pushEventToGTM = require("../commonHelpers/pushEventToGTM");
var _KlassCodeLogin = require("./studentLogin/KlassCodeLogin");
var _QRcodeLogin = require("./studentLogin/QRcodeLogin");
var _history = require("./history");
var _commonLogin = require("./commonLogin");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StudentRoutes = function StudentRoutes(_ref) {
  var _ref$showBackButton = _ref.showBackButton,
    showBackButton = _ref$showBackButton === void 0 ? true : _ref$showBackButton;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/student",
    component: function component() {
      return /*#__PURE__*/_react["default"].createElement(_studentLogin.StudentLogin, {
        showBackButton: showBackButton
      });
    },
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/student-username",
    component: _usernameLogin.StudentUsernameLogin,
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/student-klasscode",
    component: _KlassCodeLogin.StudentKlassCodeLogin,
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/student-qrcode",
    component: _QRcodeLogin.StudentQRCodeLogin,
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }));
};
var AuthSigninView = function AuthSigninView() {
  (0, _react.useEffect)(function () {
    var _sessionStorage, _sessionStorage2;
    (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 || _sessionStorage.setItem('manage_classes_path', 'Login');
    (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 || _sessionStorage2.removeItem('add_studentList');
    trackAnalyticsEvent('Account Type Screen Shown', {
      'Intent for': 'login',
      'Screen type': 'page',
      'From Page': 'signin'
    }, true);
    (0, _pushEventToGTM.pushEventToGTM)('Account Type Screen Shown', {
      'Intent for': 'login',
      'Screen type': 'page',
      'From Page': 'signin'
    });
    $('#header-mobile-content').css('position', "absolute");
    return function () {
      $('#header-mobile-content').css('position', "");
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "auth-signin-view",
    ref: function ref(_ref2) {
      if (_ref2) {
        var elementDetails = _ref2 === null || _ref2 === void 0 ? void 0 : _ref2.getBoundingClientRect();
        if (elementDetails) {
          _ref2.style.height = "calc(100vh - ".concat(elementDetails.top, "px)");
        }
      }
    },
    "data-sentry-component": "AuthSigninView",
    "data-sentry-source-file": "view.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Router, {
    history: _history.history,
    "data-sentry-element": "Router",
    "data-sentry-source-file": "view.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/signin",
    component: function component() {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: "/",
        component: _loginViewSelector.LoginViewSelector
      }), /*#__PURE__*/_react["default"].createElement(StudentRoutes, null), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "/teacher",
        component: function component() {
          return /*#__PURE__*/_react["default"].createElement(_teacherAndParentLogin.TeacherAndParentLogin, {
            isTeacher: true
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "/parent",
        component: function component() {
          return /*#__PURE__*/_react["default"].createElement(_teacherAndParentLogin.TeacherAndParentLogin, {
            isParent: true
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "*",
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: "/"
          });
        }
      }));
    },
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/student",
    component: function component() {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: "/",
        component: function component() {
          return /*#__PURE__*/_react["default"].createElement(_studentLogin.StudentLogin, {
            showBackButton: false
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(StudentRoutes, {
        showBackButton: false
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "*",
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: "/"
          });
        }
      }));
    },
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/teachers/signin",
    component: function component() {
      return /*#__PURE__*/_react["default"].createElement(_commonLogin.CommonLogin, {
        isParent: false
      });
    },
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/parents/signin",
    component: function component() {
      return /*#__PURE__*/_react["default"].createElement(_commonLogin.CommonLogin, {
        isParent: true
      });
    },
    "data-sentry-element": "Route",
    "data-sentry-source-file": "view.tsx"
  })));
};
var _default = exports["default"] = AuthSigninView;